import { Alert, Platform } from 'react-native';

/**
 * Ask the user to confirm a destructive action. On native this uses the
 * platform Alert; on web `Alert.alert`'s button callbacks never fire, so we
 * fall back to `window.confirm`. Resolves true when the user confirms.
 */
export function confirmDestructive(
  title: string,
  message: string,
  confirmLabel = 'Delete',
): Promise<boolean> {
  if (Platform.OS === 'web') {
    const ok = globalThis.confirm?.(message ? `${title}\n\n${message}` : title);
    return Promise.resolve(!!ok);
  }

  return new Promise((resolve) => {
    Alert.alert(title, message, [
      { text: 'Cancel', style: 'cancel', onPress: () => resolve(false) },
      { text: confirmLabel, style: 'destructive', onPress: () => resolve(true) },
    ]);
  });
}
